import React, { useEffect, useState, useCallback } from 'react';
import html2canvas from 'html2canvas';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { QQShare } from 'ThreeTerminal_mobile';
import Grounds from '@ifeng/three_terminal/es/base/grounds';
import { HashRouter as Router, useHistory, Route, useParams } from 'react-router-dom';
import { getStarCount, putStarCount } from '../../../services/api';

const openAppShare = () => {
    Grounds.openShare(
        'https://ishare.ifeng.com/c/s/847gcqdyKfo',
        '政府工作报告热榜来了！这些内容与你密切相关',
        '',
        'https://x0.ifengimg.com/fe/custom/govReport2021_wxicon.png',
        0,
    );
};

const pickContent = (props, name) => {
    const { content } = props;
    let result = [];

    content.modules.forEach(item => {
        if (name === item.title) result = item.data.articleList;
    });

    result.forEach(item => {
        item.thumbnail = item.thumbnail || (item.thumbnails?.image && item.thumbnails?.image[0]?.url);
    });

    return result;
};

const handleScreen = (el, callback) => {
    const width = el.offsetWidth;
    const height = el.offsetHeight - 2;
    const scale = window.devicePixelRatio;

    html2canvas(el, {
        useCORS: true,
        width,
        height,
        scrollX: 0,
        scrollY: 0,
        scale,
    }).then(canvas => {
        const context = canvas.getContext('2d');

        context.mozImageSmoothingEnabled = false;
        context.webkitImageSmoothingEnabled = false;
        context.msImageSmoothingEnabled = false;
        context.imageSmoothingEnabled = false;

        callback(canvas);
    });
};

const TopNews = errorBoundary(props => {
    const history = useHistory();
    let list = props.content.modules.filter(item => item.title.match('话题#') && item.display);
    const [len, setLen] = useState(9);
    const icons = { 爆: 'b', 沸: 'f', 新: 'x', 热: 'r' };

    return (
        <div className={styles.TopNews}>
            <img className={styles.banner} src={require('./assets/banner.png')} />
            {!window.grounds && (
                <img
                    className={styles.share}
                    src={require('./assets/share_w.png')}
                    onClick={() => {
                        props.toggleShare(1);
                    }}
                />
            )}
            <div className={styles.list}>
                {list.slice(0, len).map((item, index) => {
                    const text = item.title.split('#');

                    return (
                        <div
                            key={index}
                            onClick={() => {
                                history.push(`/detaile/${index}`);
                            }}>
                            <div>{index + 1}</div>
                            <div>{text[1]}</div>
                            {text[2] && <img src={require(`./assets/${icons[text[2]]}.png`)} alt="" />}
                        </div>
                    );
                })}
            </div>
            {len < list.length && (
                <div className={styles.more} onClick={() => setLen(len => len + 9)}>
                    <div>查看更多榜单</div>
                    <img src={require('./assets/more.png')} alt="" />
                </div>
            )}
        </div>
    );
});

const Recommend = errorBoundary(props => {
    const data = pickContent(props, '独家推荐');

    return (
        <div className={styles.Recommend}>
            <div className={styles.title}>独家推荐</div>
            <div className={styles.cards}>
                {data.map((item, index) => (
                    <div
                        key={index}
                        onClick={() => {
                            if (window.grounds) {
                                return Grounds.jumpInNative(
                                    Object.assign(item, {
                                        base62Id: item.id,
                                    }),
                                );
                            } else {
                                location.href = item.url;
                            }
                        }}>
                        <img src={item.thumbnails.image[0].url} alt="" />
                        <div>
                            <img src={require('./assets/title_icon.png')} alt="" />
                            <div>{item.title}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
});

const DetaileContent = errorBoundary(props => {
    const { item, toggleShare, listLen } = props;
    const [starCount, setStarCount] = useState(0);
    const [showAll, setShowAll] = useState(false);

    useEffect(() => {
        if (listLen) return;
        getStarCount(item.id || `govReport2021_${item.url}`).then(res => {
            setStarCount(res.data.browse[item.id || `govReport2021_${item.url}`]);
        });
    }, []);

    return (
        <div>
            <div className={styles.photo}>
                <img src={require('./assets/photo.png')} alt="" />
                <div>李克强</div>
            </div>
            <div
                className={`${styles.text} ${!showAll ? styles.text_hidden : null}`}
                onClick={() => {
                    setShowAll(true);
                }}>
                <div>{item.summary}</div>
            </div>
            {item.thumbnails?.image[0]?.url && <img className={styles.img} src={item.thumbnails.image[0].url} />}
            <div className={styles.share}>
                <div
                    onClick={() => {
                        putStarCount(item.id || `govReport2021_${item.url}`);
                        setStarCount(() => starCount + 1);
                    }}>
                    <img src={require('./assets/star.png')} alt="" />
                    <div>{starCount}</div>
                </div>
                <div
                    onClick={() => {
                        toggleShare(1);
                    }}>
                    <img src={require('./assets/share.png')} alt="" />
                    <div>分享</div>
                </div>
            </div>
        </div>
    );
});

const Detaile = errorBoundary(props => {
    const { index } = useParams();
    const history = useHistory();
    const data = props.content.modules.filter(item => item.title.match('话题#'))[index];
    const len = props.listLen || data.length;

    return (
        <div className={styles.Detaile}>
            {props.listLen && <div className={styles.title_pic}>来自话题 ——</div>}
            <div className={styles.banner}>
                {!window.grounds && (
                    <img className={styles.back} onClick={() => history.goBack()} src={require('./assets/back.png')} />
                )}
                <img className={styles.ifeng} src={require('./assets/ifeng_logo.png')} alt="" />
                <div className={styles.title}>{data.title.split('#')[1]}</div>
            </div>
            <div className={styles.list}>
                <div className={styles.title}>
                    <img src={require('./assets/title_icon2.png')} alt="" />
                    <div>精选内容</div>
                </div>
                <div className={styles.content}>
                    {data.data.articleList
                        .slice(0, len)
                        .map((item, index) => (
                            <DetaileContent
                                item={item}
                                key={index}
                                listLen={props.listLen}
                                toggleShare={props.toggleShare}
                            />
                        ))}
                </div>
            </div>
        </div>
    );
});

let firstVist = true;

const Main = errorBoundary(props => {
    let handler = null;
    const { content, toggleShare } = props;
    const [cover, setCover] = useState(firstVist ? 3 : 0);

    useEffect(() => {
        firstVist = false;

        handler = setInterval(() => {
            setCover(cover => {
                if (cover <= 1) clearInterval(handler);

                return cover >= 1 ? cover - 1 : 0;
            });
        }, 1000);
    }, []);

    return (
        <>
            {cover > 0 && (
                <div className={styles.mainCover}>
                    <img src={require('./assets/mainCover.jpg')} alt="" />
                    <div>
                        <div>{cover}</div>
                        <div
                            onClick={() => {
                                clearInterval(handler);
                                setCover(0);
                            }}>
                            跳过
                        </div>
                    </div>
                </div>
            )}
            <div style={{ opacity: cover ? 0 : 1 }}>
                <TopNews content={content} toggleShare={toggleShare} />
                <Recommend content={content} />
            </div>
        </>
    );
});

const ShareMainPic = errorBoundary(props => {
    const { content } = props;

    return (
        <div ref={props.pic} className={styles.ShareMainPic}>
            <TopNews content={content} />
            <img className={styles.bottom} src={require('./assets/share_bottom.png')} alt="" />
            <img className={styles.code} src={require('./assets/code.png')} alt="" />
        </div>
    );
});

const ShareDetailePic = errorBoundary(props => {
    const { content } = props;

    return (
        <div ref={props.pic} className={styles.ShareDetailePic}>
            <Detaile content={content} listLen={1} />
            <img className={styles.bottom} src={require('./assets/share_bottom.png')} alt="" />
            <img className={styles.code} src={require('./assets/code.png')} alt="" />
        </div>
    );
});

const Layout = errorBoundary(props => {
    const { content } = props;
    const [showShareImg, toggleShare] = useState(false);
    const [dIndex, setDIndex] = useState(0);
    const [shareMainImg, setShareMainImg] = useState(null);
    const [shareDetaileImg, setShareDetaileImg] = useState(null);

    const qqShareCofig = {
        title: '政府工作报告热榜来了！这些内容与你密切相关',
        img: 'https://x0.ifengimg.com/fe/custom/govReport2021_wxicon.png',
        desc: '',
    };

    const pic = useCallback(node => {
        setTimeout(() => {
            handleScreen(node, canvas => {
                setShareMainImg(canvas.toDataURL());
            });
        }, 1000);
    }, []);

    const pic2 = useCallback(
        node => {
            setTimeout(() => {
                handleScreen(node, canvas => {
                    setShareDetaileImg(canvas.toDataURL());
                });
            }, 1000);
        },
        [dIndex],
    );

    const toggleShareImg = (type, index) => {
        if (index !== undefined) setDIndex(index);
        if (window.grounds) return openAppShare();
        toggleShare(type);
    };

    return (
        <div className={styles.layout}>
            <Router>
                <Route exact path="/">
                    <Main content={content} toggleShare={toggleShareImg} />
                </Route>
                <Route exact path="/detaile/:index">
                    <Detaile content={content} toggleShare={toggleShareImg} setDIndex={setDIndex} />
                    <ShareDetailePic dIndex={dIndex} content={content} pic={pic2} />
                </Route>
            </Router>
            <ShareMainPic content={content} pic={pic} />
            {showShareImg && (
                <div
                    className={styles.alert}
                    onClick={() => {
                        toggleShare(null);
                    }}>
                    <img src={showShareImg === 1 ? shareMainImg : shareDetaileImg} alt="" />
                </div>
            )}
            <QQShare content={qqShareCofig} />
        </div>
    );
});

export default Layout;
